import React, { useEffect, useRef, useState } from 'react'
import _debounce from 'lodash.debounce'
import TextInputField from 'components/Form/TextInputField'
import ModalWrapper from 'components/ModalWrapper'
import { lang } from 'utils/helpers'
import './styles.scss'
import { UserCard } from 'components/Sidemenu/SideMenuInChat/components'
import { apiInchat } from 'api'
import ModalCreateChannel from '../ModalCreateChannel'

const ModalChannelList = ({ isOpenModal, handleOpenModal, getConversationList, conversationAction }) => {
  const [inputFilter, setInputFilter] = useState('')
  const [dataChannels, setDataChannels] = useState([])
  const [isOpenCreate, setIsOpenCreate] = useState(false)
  const [messageError, setMessageError] = useState('')
  const [page, setPage] = useState(1)
  const limit = 30

  const debouncedSearchChannel = useRef(
    _debounce(async text => {
      getData(false, text)
    }, 350)
  ).current

  useEffect(() => {
    if(isOpenModal) {
      getData()
    }else{
      clearAll()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenModal])

  useEffect(() => {
    const modalContent = document.querySelector('#listChannelInModal')
    if(modalContent){
      if(isOpenModal){
        modalContent.addEventListener('scroll', scrollCheck)
      }else{
        modalContent.removeEventListener('scroll', scrollCheck)
      }
    }
    return () => {if(modalContent) modalContent.removeEventListener('scroll', scrollCheck)}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataChannels])

  function scrollCheck(event) {
    const scrollTop = event.target.scrollTop
    const scrollHeight = event.target.scrollHeight
    const clientHeight = event.target.clientHeight
    if (scrollTop + clientHeight >= scrollHeight) {
      handleNextPage()
    }
  }

  const handleNextPage = () => {
    getData(true)
  }

  const handleChangeInput = (value) => {
    setInputFilter(value)
    debouncedSearchChannel(value)
  }

  const getData = async (nextPage=false, input='') => {
    setMessageError('')
    try {
      const newPage = nextPage ? page + 1 : 1
      if(nextPage && dataChannels.length && dataChannels.length < (page * limit)) return
      let body = {
        page: newPage,
        limit,
      }
      if(input || inputFilter) body = { ...body, name: input || inputFilter }
      const { data } = await apiInchat.getAllChannels(body)
      const { channels } = data
      let newChannels = [...channels]
      if(nextPage){
        newChannels = [...dataChannels, ...newChannels]
      }
      setDataChannels(newChannels)
      setPage(state => state + 1)
    } catch (error) {
      setMessageError(lang('dashboard_error-get-channel'))
    }
  }

  const handleClickExit = async (conversation) => {
    setMessageError('')
    try {
      await conversationAction({
        type: 'leave',
        conversationId: conversation._id,
        conversationType: conversation.type
      })
      getData()
      getConversationList()
    } catch (error) {
      setMessageError(lang('dashboard_error_channel_exit'))
    }
  }

  const handleClickJoin = async (conversation) => {
    setMessageError('')
    try {
      await conversationAction({
        type: 'join',
        conversationId: conversation._id,
        conversationType: conversation.type
      })
      getData()
    } catch (error) {
      setMessageError(`${lang('dashboard_error_channel_join')} ${conversation.name || ''}`)
    }
  }

  const handleOpenCreate = () => {
    if (isOpenCreate){
      getData()
      getConversationList()
    }
    setIsOpenCreate(state => !state)
    clearAll()
  }

  const clearAll = () => {
    setInputFilter('')
    setMessageError('')
    setPage(1)
  }

  return (
    <>
      <ModalWrapper
        isOpen={isOpenModal}
        toggle={handleOpenModal}
        header={lang('dashboard_channels')}
        body={
          <div className='inchat-channel-container'>
            <TextInputField
              classNameWrapper='text-filter-channel'
              name={'search_channel'}
              placeholder={`${lang('dashboard_search_channel')}...`}
              value={inputFilter}
              onChange={handleChangeInput}
              className={'icon-filter-channel'}
            />
            <div className='inchat-channel-container__list-channel' id='listChannelInModal'>
              {dataChannels.map((conversation, index) => {
                return (
                  <UserCard
                    key={conversation._id + index}
                    conversation={conversation}
                    onClick={() => undefined}
                    typeCard='modal'
                    onClickExit={handleClickExit}
                    handleClickJoin={handleClickJoin}
                  />
                )
              })}
            </div>
          </div>
        }
        error={messageError}
        headerBtn={handleOpenCreate}
        headerBtnText={lang('dashboard_create_new_channel')}
        footer={<></>}
      />
      <ModalCreateChannel
        handleOpenCreate={handleOpenCreate}
        isOpenCreate={isOpenCreate}
      />
    </>
  )
}

export default ModalChannelList